import cloneDeep from 'lodash/cloneDeep';
import { decodeHtml } from './vue-utils.common';

export default {
    mixins: [
        decodeHtml
    ],
    props: {
        initialDataId: String,
        componentData: Object
    },
    data() {
        return {
            data: null,
            fullyLoaded: false
        }
    },
    created() {
        if (this.componentData) {
            this.data = cloneDeep(this.componentData);
        }
    },
    mounted() {
        this.$nextTick(() => {
            if (this.$el
                && typeof(this.$el.outerHTML) !== 'undefined') {
                this.$el.classList.add("component-is-mounted");
                this.fullyLoaded = true;

                const contentLoaders = Array.from(this.$el.querySelectorAll('[am-content-placeholder]'));

                contentLoaders.forEach(contentLoader => {
                    const currentAttribute = contentLoader.getAttribute('am-content-placeholder') || '';

                    if (!currentAttribute.includes('loaded')) {
                        contentLoader.setAttribute('am-content-placeholder', `${currentAttribute} loaded`);
                    }
                });
            }
        });
    }
};